import { useEffect } from 'react';

export default function SEO({ title, description, keywords }) {
  useEffect(() => {
    const baseTitle = "UMED Mental Hospital & Deaddiction Centre";
    document.title = title ? `${title} | ${baseTitle}` : `${baseTitle} | Sangli Miraj, Maharashtra`;

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', description);
      }
    }

    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      }
    }
  }, [title, description, keywords]);

  return null;
}
